import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        assessment : {
            item:[]
        },
        isReload: false,
    },

    mutations: {
        assessment(state, obj) {
            state.assessment = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.assessment('exp', data, {})
                .then((response) => {
                    store.commit("assessment/assessment", response.data.data[0])
                    return response

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    if (response.data && response.data.data) {
                        store.commit("assessment/assessment", response.data.data)
                    }
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    if (response.data && response.data.data) {
                        store.commit("assessment/assessment", response.data.data)
                    }
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },

        remove({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.assessment('delete', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",false)
                    store.commit("assessment/isReload",true)
                    return response

                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },

    },

    getters: {
        assessment(state, obj) {
            return state.assessment;
        },

        isReload(state, obj) {
            return state.isReload;
        }
    },
};

export default ServerModule;
